import { render, staticRenderFns } from "./WooriCrowdfunding.vue?vue&type=template&id=72a01bf0&scoped=true&"
import script from "./WooriCrowdfunding.vue?vue&type=script&lang=js&"
export * from "./WooriCrowdfunding.vue?vue&type=script&lang=js&"
import style0 from "./WooriCrowdfunding.vue?vue&type=style&index=0&id=72a01bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a01bf0",
  null
  
)

export default component.exports